import React from 'react';
import { Star, Phone, MessageCircle } from 'lucide-react';
import { contactInfo } from '../data/mock';

const SeoContentSection = () => {
  return (
    <section className="py-16 sm:py-24 bg-black">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <article className="prose prose-invert prose-amber max-w-none">
          {/* Main SEO Content */}
          <div className="bg-gray-900/30 border border-amber-500/10 rounded-2xl p-6 sm:p-10">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-6 text-center">
              <span className="text-amber-500">Retour Affectif</span> : Grand Marabout Africain
            </h2>
            
            <div className="space-y-6 text-gray-300 text-base sm:text-lg leading-relaxed">
              <p>
                <strong className="text-white">Maître Diamma</strong> est un <strong className="text-amber-500">grand marabout africain</strong> reconnu 
                internationalement pour son expertise dans le domaine du <strong>retour affectif</strong>. Avec plus de <strong>30 ans d'expérience</strong> 
                et <strong>plus de 290 clients satisfaits</strong> à travers le monde, il est devenu la référence incontournable pour toute personne 
                souhaitant <strong>récupérer son ex</strong> ou <strong>faire revenir l'être aimé</strong>.
              </p>

              <h3 className="text-xl sm:text-2xl font-bold text-white mt-8">
                Qu'est-ce que le Retour Affectif ?
              </h3>
              <p>
                Le <strong>retour affectif</strong> est un ensemble de <strong>rituels spirituels ancestraux</strong> destinés à ramener une personne aimée 
                qui s'est éloignée. Ces pratiques, transmises de génération en génération dans les traditions africaines, permettent de 
                <strong> raviver les sentiments</strong>, de <strong>lever les blocages émotionnels</strong> et de <strong>réunir les couples séparés</strong>.
              </p>

              <h3 className="text-xl sm:text-2xl font-bold text-white mt-8">
                Les Différentes Formes de Magie pour le Retour Affectif
              </h3>
              <p>
                <strong className="text-amber-500">Maître Diamma</strong> maîtrise les trois formes principales de magie utilisées dans le retour affectif :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong className="text-gray-100">Magie Blanche</strong> : Utilise les énergies positives pour attirer l'amour et la protection. Idéale pour les situations où les sentiments sont encore présents.</li>
                <li><strong className="text-gray-100">Magie Noire</strong> : Plus puissante, elle intervient dans les cas complexes nécessitant une action rapide et définitive pour faire revenir l'ex.</li>
                <li><strong className="text-red-400">Magie Rouge</strong> : Spécialement dédiée à l'amour et à la passion, elle ravive le désir et l'attraction entre deux personnes.</li>
              </ul>

              <h3 className="text-xl sm:text-2xl font-bold text-white mt-8">
                Pourquoi Choisir Maître Diamma pour votre Retour Affectif ?
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>Expertise reconnue</strong> : Plus de 30 ans de pratique des arts mystiques africains</li>
                <li><strong>Résultats rapides</strong> : Effets visibles en 24 à 72 heures dans la plupart des cas</li>
                <li><strong>Intervention mondiale</strong> : Rituels efficaces à distance pour les clients de France, Belgique, Suisse, Canada, Afrique et partout dans le monde</li>
                <li><strong>Confidentialité absolue</strong> : Votre vie privée est totalement protégée</li>
                <li><strong>Suivi personnalisé</strong> : Accompagnement jusqu'à l'obtention des résultats</li>
              </ul>

              <h3 className="text-xl sm:text-2xl font-bold text-white mt-8">
                Comment Récupérer son Ex avec Maître Diamma ?
              </h3>
              <p>
                <strong>Récupérer son ex</strong> ou <strong>reconquérir son ex</strong> est possible grâce aux rituels puissants de Maître Diamma. 
                Que votre ex soit parti(e) avec quelqu'un d'autre, qu'il/elle refuse de vous parler ou que la séparation date de plusieurs mois, 
                <strong className="text-amber-500"> Maître Diamma peut vous aider</strong>.
              </p>
              <p>
                Le processus est simple : contactez Maître Diamma par téléphone ou WhatsApp, exposez votre situation en toute confidentialité, 
                et il déterminera le rituel le plus adapté à votre cas. Les premiers résultats apparaissent généralement dans les 
                <strong> 24 à 72 heures</strong> suivant l'intervention.
              </p>

              <h3 className="text-xl sm:text-2xl font-bold text-white mt-8">
                Maître Diamma : Marabout à Paris, Lyon, Marseille, Bruxelles, Genève, Montréal...
              </h3>
              <p>
                <strong className="text-amber-500">Maître Diamma</strong> intervient dans toutes les grandes villes francophones : 
                <strong> marabout Paris</strong>, <strong>marabout Lyon</strong>, <strong>marabout Marseille</strong>, <strong>marabout Toulouse</strong>, 
                <strong>marabout Bordeaux</strong>, <strong>marabout Bruxelles</strong>, <strong>marabout Genève</strong>, <strong>marabout Montréal</strong>, 
                et bien d'autres. Grâce aux rituels à distance, les clients du monde entier peuvent bénéficier de son expertise.
              </p>
            </div>

            {/* CTA */}
            <div className="mt-10 p-6 bg-amber-500/10 border border-amber-500/30 rounded-xl text-center">
              <p className="text-white font-bold text-xl mb-4">
                Ne laissez pas votre histoire d'amour se terminer
              </p>
              <p className="text-gray-300 mb-6">
                Contactez Maître Diamma maintenant et récupérez votre ex en 24-72h
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
                  className="inline-flex items-center px-6 py-4 bg-amber-500 text-black font-bold rounded-full hover:bg-amber-400 transition-colors"
                >
                  <Phone className="w-5 h-5 mr-2" />
                  {contactInfo.phone}
                </a>
                <a
                  href={contactInfo.whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-6 py-4 bg-green-600 text-white font-bold rounded-full hover:bg-green-700 transition-colors"
                >
                  <MessageCircle className="w-5 h-5 mr-2" />
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
};

export default SeoContentSection;
